import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckCircle, faSync } from '@fortawesome/free-solid-svg-icons';

const Checkmark = ({ isChecked, onChecked, disabled, callback, circle, iconProps = {} }) => {
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(isChecked);

    useEffect(() => {
        setChecked(isChecked)
      }, [isChecked]);


    const handleCheckboxChange = async () => {
        if (disabled || loading) return; // Prevent changes if disabled or already processing
        
        const newChecked = !isChecked;
        if (newChecked) {
            // If checked, execute onChange
            if (onChecked) {
                setLoading(true);
                const result = await onChecked();
                setChecked(result);
                setLoading(false);
                if(callback){
                    callback();
                } 
            }
        }
    }

    return <div className="mr-2 ml-2">
        { loading ?
             <FontAwesomeIcon className="text-secondary infinite-rotate faded" icon={faSync} />
            :
            <FontAwesomeIcon
            icon={circle ? faCheckCircle: faCheck}
            className={`pointer fa-2xl ${checked ? 'text-primary' : 'text-secondary'}`}
            onClick={handleCheckboxChange}
            style={{ cursor: disabled || loading ? 'not-allowed' : 'pointer' }}
            {...iconProps}
        />}
    </div>

};

export default Checkmark;
